import * as Color from "color"
import PptxGenJS, { Slide } from "pptxgenjs"
import { Decomposition } from "../debt-table"
import * as DebtUtils from "../utils"
import { ReportConfiguration } from "../../../configuration"
import { MasterSlide } from "../../pptx-configuration/master-slides"
import {
	Placeholder,
	getPlaceholderBodyOptions
} from "../../pptx-configuration/placeholders"
import { DocumentSection } from "../../types"
import { formatTitle } from "../../utils"
import { LoanWithDecomposition } from "../../../../../model"

export function checkInterestReimbursementSection(
	configuration: ReportConfiguration
): boolean {
	const interestReimbursement = configuration.debt.interestReimbursement
	return interestReimbursement.globalCharts || interestReimbursement.tables
}

export function createInterestReimbursementSection(
	pptx: PptxGenJS,
	configuration: ReportConfiguration,
	numbering: number[],
	childDecomposedLoans: any,
	years: number[],
	checked:string
): DocumentSection {
	const slides: Slide[] = []
	const slidesTitle = formatTitle("Remboursement intérêts", numbering)
	const interestReimbursement = configuration.debt.interestReimbursement
	const placeholderBody = getPlaceholderBodyOptions()
	const baseColor = new Color(configuration.table.header.backgroundColor)

		DebtUtils.includeDebtTable(
			pptx,
			slidesTitle,
			"management-report-debt-interest-reimbursement",
			Decomposition.InterestReimbursement,
			childDecomposedLoans,
			years,
			configuration,
			checked
		)

	return { slides, title: slidesTitle }
}



// WEBPACK FOOTER //
// ./src/component/management-report/generator/budgetGenerator/interest-reimbursement-generator/index.tsx